"use client";
import { useState } from "react";
import { Token } from "./updateStockpriceTypes";

export function renderTokens(tokens: Token[]) {
  return tokens.map((token, idx) => (
    <span
      key={token.key ? `${token.key}-${idx}` : `${token.value}-${idx}`}
      className={
        token.type === "placeholder"
          ? "font-[500] text-[#1A1A1A]"
          : "font-[400] text-[#666666]"
      }
    >
      {token.value}
    </span>
  ));
}

const SharePriceUpdateClient = ({
  tokens,
  truncatedTokens,
  readMoreText,
  readLessText,
}: {
  tokens: Token[];
  truncatedTokens: Token[];
  readMoreText?: string;
  readLessText?: string;
}) => {
  const [showAll, setShowAll] = useState(false);
  const isTruncated =
    truncatedTokens.length < tokens.length ||
    truncatedTokens[truncatedTokens.length - 1]?.value.endsWith("...");

  return (
    <div>
      <div className="hidden">{renderTokens(tokens)}</div>
      <div className="max-w-full pb-[2px] text-left text-[14px] md:text-[16px]">
        {renderTokens(showAll ? tokens : truncatedTokens)}
      </div>
      {isTruncated && (
        <button
          onClick={() => setShowAll((prev) => !prev)}
          className="text-link-primary cursor-pointer text-[14px] font-[500]"
          aria-expanded={showAll}
        >
          {showAll ? readLessText : readMoreText}
        </button>
      )}
    </div>
  );
};

export default SharePriceUpdateClient;
